import Navbar from "../navbar/navbarComponent.vue";
import Footer from "../footer/footerComponent.vue";
import fab from "vue-fab";

export default {
    name: "LayoutContainer",

    components: { fab, Navbar, Footer },

    props: {},

    data: () => {
        return {
            bgColor: "#20a8d8",
            position: "bottom-right",
            mainIcon: "message",
            mainTooltip: "Contact",
            fabActions: [
                {
                    name: "facebook",
                    icon: "facebook",
                    tooltip: "https://www.facebook.com/asigurarilerca",
                    color: "#4267B2"
                },
                {
                    name: "phone",
                    icon: "phone",
                    tooltip: "0799 879 828",
                    color: "#03af53"
                },
                {
                    name: "contact",
                    icon: "contact_page",
                    tooltip: "Formular de contact",
                    color: "#000"
                }
            ]
        };
    },

    computed: {},

    methods: {
        phoneCall() {
            window.location.href = "tel:0799879828";
        },
        openFacebook() {
            window.open("https://www.facebook.com/asigurarilerca", "_blank");
        },
        goToContact() {
            if (this.$router.currentRoute.path === "/") {
                document.querySelector(`#contact`).scrollIntoView({
                    behavior: "smooth"
                });
            } else {
                this.$router.push("/#contact");
            }
        }
    }
};
